var exports = {
  "kJ": "TemplateEmbed.module__iconCircle___RVNYOU",
  "GP": "TemplateEmbed.module__iconOnBrand___RVNYOU",
  "h_": "TemplateEmbed.module__description___RVNYOU",
  "M1": "TemplateEmbed.module__stats___RVNYOU",
  "gW": "TemplateEmbed.module__statDot___RVNYOU",
};

module.exports = exports;
